import { Table, Justify, StatusTip, ConfigProvider } from 'tea-component';
import React, { ReactNode, useEffect, useState } from 'react';
import { history, useParams, connect } from 'umi';
import { getGameBasicinfoNew } from '@/pages/intelligence/services/topcharts';
import {
  ageBreakdownList,
  genderBreakdownList,
  handleTableBarList,
} from '@/pages/intelligence/pages/TopCharts/MobileGames/Demographics/_config/utils';
import { useIntl } from 'umi';

// import './InsideTable.less';
const { LoadingTip } = StatusTip;

const { scrollable, autotip, expandable, pageable } = Table.addons;

function TableContent(props) {
  const {
    fetchParams, //点击跳转接口请求参数体
    columns,
    appids,
    unifiedId,
  } = props;
  // 表格数据

  const { formatMessage } = useIntl(); // 中英切换方法
  // const dispatch = useDispatch();
  const defaultPage = 5;
  // const [columns, setColumns] = useState();
  const [pageIndex, setPageIndex] = useState(1); //好接收搜索后重置分页器
  const [pageSize, setPageSize] = useState(defaultPage);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(true);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    getTableList({ ...fetchParams, game_code: appids });
  }, []);

  const getTableList = async (fetchParams: any) => {
    setTableLoading(true);
    try {
      const res = await getGameBasicinfoNew(fetchParams);
      const { rank_list = [], total = 0 } = res?.data || {};

      const tableList = rank_list.map((item) => {
        const metricList = item?.metric_list;
        const ageMetricList = handleTableBarList(
          fetchParams.order_metric,
          ageBreakdownList,
          metricList,
        );
        const genderMetricList = handleTableBarList(
          fetchParams.order_metric,
          genderBreakdownList,
          metricList,
        );

        return {
          ...item,
          insideTable: true,
          unified_id: unifiedId,
          ageMetricList: ageMetricList,
          genderMetricList: genderMetricList,
        };
      });
      setTotal(tableList?.length);
      setTableList(tableList);
      setTableLoading(false);
    } catch (err) {
      setTableList([]);
      setTotal(0);
      setTableLoading(false);
    }
  };

  return (
    <>
      <ConfigProvider locale="en">
        {tableLoading ? (
          <div
            // className="streaming-metric-loading"
            style={{
              background: '#F5F5F8',
              height: 120,
              textAlign: 'center',
              paddingTop: 55,
            }}
          >
            <LoadingTip />
          </div>
        ) : (
          <div //id="demographics-topcharts-table"
          // className={showShadow ? "demographics-topcharts-insgintabletable__shadow" : ''}
          >
            <Table
              recordKey={'app_id'}
              hideHeader={true}
              // className={`general-table ${!tableList?.length ? 'loading' : ''}`}
              records={tableList}
              columns={[...(columns || [])]}
              addons={[
                pageable({
                  stateTextVisible: true,
                  // recordCount: tableLoading ? 0 : total,
                  pageSizeVisible: total > defaultPage,
                  pageIndexVisible: total > defaultPage,
                  jumpVisible: total > defaultPage,
                  endJumpVisible: total > defaultPage,
                  stateText: formatMessage(
                    { id: 'dbi_pagination_total' },
                    { total: total ?? 0 },
                  ),
                  pageSizeOptions: [defaultPage, 10, 15],
                }),
                scrollable({ minHeight: 10 }),
                autotip({
                  emptyText: 'No data under current selections',
                }),
                expandable({
                  // expandedKeys,
                  // gapCell: 1,
                  shouldRecordExpandable: (record) => {
                    return false;
                  },
                }),
              ]}
            />
          </div>
        )}
      </ConfigProvider>
    </>
  );
}

export default connect((state) => ({
  // topcharts: state.topcharts,
}))(TableContent);
